module.exports = __webpack_public_path__ + "img/y-269.0cca67cf.png";